module.exports = __webpack_public_path__ + "img/V13.49a3b92d.png";